import React, { useEffect, useRef, useState } from 'react'

interface IProps {
	item: any
}

function Tooltip({ item }: IProps) {
	const [showTooltip, setShowTooltip] = useState(false)

	const node = useRef<any>()

	const handleClick = (e: any) => {
		if (node.current?.contains(e.target)) {
			return
		}
		setShowTooltip(false)
	}

	useEffect(() => {
		document.addEventListener('mousedown', handleClick)
		return () => {
			document.removeEventListener('mousedown', handleClick)
		}
	})
	return (
		<div
			ref={node}
			onClick={() => setShowTooltip(!showTooltip)}
			className="tooltip-tip position-relative p-2">
			{showTooltip && (
				<>
					<span className=" tooltip-text ">
						<div className="arrow-down"></div>
						{item?.text!}
						{item?.value}
					</span>
				</>
			)}
		</div>
	)
}

export default Tooltip
